import { UntypedFormControl } from '@angular/forms';

export enum DynamicFormControlType {
  INPUT = 'INPUT',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SELECT = 'SELECT',
}

export interface DynamicFormField {
  id: string;
  label: string;
  required: boolean;
  formControl: UntypedFormControl;
  type: DynamicFormControlType;
  config?: DynamicFormFieldConfig;
}

export interface DynamicFormFieldConfig {
  id?: string;
  label?: string;
  required?: boolean;
  formControl?: UntypedFormControl;
  options?: { text: string; value: string }[];
}
